import React from 'react'
import RecieptListSection from '../../../component/billing-payments/invoice/reciept/RecieptListSection'


function RecieptList() {
  return (
    <div className='page-body'>
    <RecieptListSection/>
    </div>
  )
}

export default RecieptList
